
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.68 35.87v-2.75a8.17 8.17 0 007.44-7.44h2.75v-1.36h-2.74a8.17 8.17 0 00-7.45-7.45v-2.74h-1.36v2.74a8.17 8.17 0 00-7.45 7.45h-2.74v1.36h2.75a8.17 8.17 0 007.44 7.44v2.75zm0-4.11v-2.68h-1.36v2.68a6.8 6.8 0 01-6.08-6.08h2.68v-1.36h-2.68a6.77 6.77 0 016.08-6.08v2.68h1.36v-2.68a6.77 6.77 0 016.08 6.08h-2.68v1.36h2.68a6.79 6.79 0 01-6.07 6.08z","fill":"var(--map-icons)"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/map_icons/center_workspace.svg